import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import * as moment from 'moment';


import { AuthService } from '../services/auth.service';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import { ModeloVeiculoService } from '../services/modelo-veiculo.service';

@Component({
  selector: 'app-intervencoes',
  templateUrl: './intervencoes.component.html',
  styleUrls: ['./intervencoes.component.css'],
  animations: [loadingFade, modal, alert]
})
export class IntervencoesComponent implements OnInit {
  public loading = false;

  public formFiltro: FormGroup;

  public veiculos_array = [];
  public modelo_veiculo_tipo_despesa_array = [];
  public manutencoes_array = [];
  public usuario_id;
  private dataAtual = moment(new Date()).format("YYYY-MM-DD");

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  // filtro
  public filtro = [];
  public dadosFiltrados = [];
  public showFilter = true;

  public clientes;
  public unidades;
  public tiposVeiculo;
  public modelosVeiculo;
  public marcasVeiculo;

  constructor(
    private fb: FormBuilder,
    private authSvc: AuthService,
    private veiculoSvc: VeiculoService,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private marcaVeiculoSvc: MarcaVeiculoService,
    private modeloVeiculoSvc: ModeloVeiculoService,
  ) { }

  ngOnInit() {
    this.criaFiltro();
    this.usuario_id = this.authSvc.getUsuarioId();
    this.pegaVeiculosManutencao();
  }
  // ****************************************
  // FILTRO
  // ****************************************

  criaFiltro() {
    this.pegaClientes();
    this.pegaUnidades();
    this.pegaModelosVeiculo();
    this.pegaMarcasVeiculo();
    this.formFiltro = this.fb.group({
      cliente_id___cliente: null,
      veiculo_unidade___veiculo_unidade: null,
      veiculo_id___veiculo: null,
      veiculo_placa___placa: null,
      marca_veiculo_id___veiculo: null,
      modelo_veiculo_id___veiculo: null
    });
  }

  filtra() {
    this.filtro = this.formFiltro.value;
    this.dadosFiltrados = new FiltroPipe().transform(this.veiculos_array, this.filtro);
    this.count = this.dadosFiltrados.length;
    this.page = 1;
  }

  expandPanel() {
    this.showFilter = this.showFilter == true ? false : true;
  }


  pegaClientes() {
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.clientes = data;
    });
  }

  onChangeCliente(evento) {
    this.formFiltro.controls.unidade_id___unidade.setValue(null);
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidades() {
    this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaModelosVeiculo() {
    this.modeloVeiculoSvc.getModelosVeiculo().then((data: any[]) => {
      this.modelosVeiculo = data;
    });
  }


  pegaMarcasVeiculo() {
    this.marcaVeiculoSvc.getMarcasVeiculo().then((data: any[]) => {
      this.marcasVeiculo = data;
    });
  }

  onChangeMarca(evento) {
    this.formFiltro.controls.modelo_veiculo_id___veiculo.setValue(null);
    this.modeloVeiculoSvc.getModelosVeiculoByMarca(evento.marca_veiculo_id).then((data: any[]) => {
      this.modelosVeiculo = data;
    });
  }

  // ****************************************


  pegaVeiculosManutencao() {
    this.loading = true;

    this.veiculoSvc.getVeiculosManutencoes(this.authSvc.getUsuarioId()).then((data: any) => {
      for(let index in data){
        this.veiculos_array.push(data[index]);
      }
      this.count = this.veiculos_array.length;
      this.loading = false;
    }).catch((err) => {
      console.log(err);
    });

  }

  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  diasRestantes(dataPrevista) {
    let oneDay = 86400 * 1000;
    let dataAtual = new Date(new Date().toISOString().substr(0, 10)).getTime();
    let dataFinal = new Date(dataPrevista).getTime();

    let result = (dataAtual - dataFinal) / (oneDay);

    return result * -1;
  }

  nivel(kmAtual, kmPrevista, dataPrevista) {
    if (kmAtual > kmPrevista || this.dataAtual > dataPrevista) {
      return 'late';
    }
    else if (kmAtual >= (kmPrevista - 1000) || this.dataAtual >= moment(dataPrevista).subtract('15', 'days').format('YYYY-MM-DD')) {
      return 'near';
    }
    else {
      return 'onTime';
    }
  }

}

